import React from "react";

function classNames(...values) {
  return values.filter(Boolean).join(" ");
}

const SearchInput = React.forwardRef(function SearchInput(
  { icon = null, inputRef = null, containerClassName = "", inputClassName = "", ...inputProps },
  ref
) {
  return (
    <div ref={ref} className={classNames("helper-input search-field-shell search-field-shell--with-leading-icon", containerClassName)}>
      {icon ? React.cloneElement(icon, { "aria-hidden": true, className: classNames("search-field-icon", icon.props.className) }) : null}
      <input ref={inputRef} className={classNames("search-field-input", inputClassName)} {...inputProps} />
    </div>
  );
});

export default SearchInput;
